module.exports = __webpack_public_path__ + "img/align-vertical-bottom.32067f83.svg";